import SqFetch from 'typescript/application/sq_fetch';
import { _handleResponse } from 'typescript/clients/utilities/handle_http_response';
import { PickupOption } from 'typescript/types/api/pickup_options';
import { OrderPickupPerson } from 'typescript/types/api/solidshop';

export const LIST_PICKUP_OPTIONS_FOR_POSTAL_CODE_URL =
  '/shop/api/v1/checkout/bopis/find_availabilty_by_postal_code';
export const RESERVE_PICKUP_OPTION_URL =
  '/shop/api/v1/checkout/bopis/reserve_pickup_option';
export const UPDATE_PICKUP_PERSON_URL =
  '/shop/api/v1/checkout/bopis/update_pickup_person';

/**
 * Get pickup options near postal code; cart contents are also factored in on backend
 * @returns Promise<PickupOption[]> - array of pickup options to display
 */
export const listPickupOptions = async ({
  orderNumber,
  postalCode,
}: {
  orderNumber: string;
  postalCode: string;
}): Promise<PickupOption[]> => {
  const response = await SqFetch.post(LIST_PICKUP_OPTIONS_FOR_POSTAL_CODE_URL, {
    postal_code: postalCode,
    order_number: orderNumber,
  });

  return _handleResponse(response);
};

/**
 * Reserve pickup option chosen and ensure BOPIS is shipping method
 * @returns the ID/location_id of the option successfully reserved
 */
export const reservePickupLocation = async ({
  orderNumber,
  chosenPickupLocationId,
  searchPostalCode,
}: {
  orderNumber: string;
  chosenPickupLocationId: string;
  searchPostalCode?: string;
}): Promise<string> => {
  const response = await SqFetch.post(RESERVE_PICKUP_OPTION_URL, {
    location_id: chosenPickupLocationId,
    search_postal_code: searchPostalCode,
    order_number: orderNumber,
  });

  return _handleResponse(response);
};

/**
 * Update BOPIS order pickup person information
 * @returns success or error message
 */
export const updatePickupPerson = async ({
  orderNumber,
  pickupPersonInfo,
}: {
  // not sure if this should stay as Record<string, string>
  orderNumber: string;
  pickupPersonInfo: OrderPickupPerson;
}): Promise<{ success: boolean }> => {
  const response = await SqFetch.post(UPDATE_PICKUP_PERSON_URL, {
    order_number: orderNumber,
    pickup_person_info: pickupPersonInfo,
  });

  return _handleResponse(response);
};
